import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';

import { favoriteImage } from '~/modules/gallery';

import { useAppDispatch, useAppSelector } from '~/hooks/redux';

import Button, { ButtonProps } from '..';
import styles from './LikeButton.scss';

const cx = classNames.bind(styles);

interface Props {
  image: {
    id: number;
    favorite: boolean;
    favorites_count: number;
  };
}

export const LikeButton = ({
  image,
  ...props
}: Props & Omit<ButtonProps, 'children'>) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const isSignedIn = useAppSelector((state) => state.currentUser.isSignedIn);
  const [isSubmitting, setSubmitting] = useState(false);

  const onFavorite = async () => {
    if (!isSignedIn) return navigate('/login');
    if (isSubmitting) return;

    setSubmitting(true);
    // @ts-expect-error
    await dispatch(favoriteImage(image.id, !image.favorite));
    queryClient.refetchQueries({
      queryKey: ['gallery']
    });
    setSubmitting(false);
  };

  // const label = image.favorite ? (
  //   <FormattedMessage id="LikeButton_Liked" defaultMessage="Liked" />
  // ) : (
  //   <FormattedMessage id="LikeButton_Like" defaultMessage="Like" />
  // );

  return (
    <Button
      className={cx('LikeButton', {
        'LikeButton--active': image.favorite,
      })}
      color="flatBlue"
      onClick={onFavorite}
      disabled={isSubmitting}
      {...props}
    >
      {image.favorites_count}
    </Button>
  );
};

export default LikeButton;
